<template>
  <div v-if="broker != null" class="w-full lg:w-1/2">

    <div class="text-lg">Lead Capture Form</div>
    
    <div class="my-8">
      <div class="text-sm">Enable my lead capture form</div>

      <div class="form-line">
        <div class="mt-2 flex items-center">
          <input type="radio" name="inout-enable-clead-capture-form" v-model="leadCaptureEnabled" value="1" id="inout-enable-clead-capture-form-yes" />
          <label for="inout-enable-clead-capture-form-yes" class="ml-2 mr-8 text-sm">Yes</label>
        
          <input type="radio" name="inout-enable-clead-capture-form" v-model="leadCaptureEnabled" value="0" id="inout-enable-clead-capture-form-no" />
          <label for="inout-enable-clead-capture-form-no" class="ml-2 text-sm">No</label>
        </div>
      </div>

      <div class="label-line text-sm">
        Your lead capture form can be accessed via the following link.
      </div>

      <div class="mt-2 bg-gray-200 p-4 text-base text-gray-800 flex items-center">
        <a :href="getFrontendHost + '/client/lead-capture/' + broker.id + '/primary-reason'" class="underline" target="_blank">
          {{ getLeadCaptureUrl(broker.id) }}
        </a>

        <button class="text-white bg-blue-500 px-2 py-1 rounded text-xs ml-4" v-on:click="copyUrl">Copy</button>
      </div>

      <div class="label-line text-sm">
        Facebook Pixel Code
      </div>

      <div class="mt-1 text-gray-600">
        If you wish to track your lead capture form via Facebook Pixel, you can copy &amp; paste your
        Facebook Pixel code below.
      </div>

      <div class="form-line">
        <textarea class="input-standard h-40" v-model="fbPixel"></textarea>
      </div>

      <div class="mt-12">
        <SubmitButton2 :onClick="submit" :loading="loading" />
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      SubmitButton2
    },

    data () {
      return {
        loading           : false,
        broker            : null,
        leadCaptureEnabled: 1,
        url               : 'hello',
        fbPixel           : null
      }
    },

    created() {
      this.broker             = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)
      this.leadCaptureEnabled = this.broker.lead_capture_enabled ? 1 : 0
      this.fbPixel            = this.broker.fb_pixel != null ? atob(this.broker.fb_pixel) : null
    },

    methods : {

      onCopy(e) {
        // alert('You just copied: ' + e.text)
      },

      onError(e) {
        // alert('Failed to copy texts')
      },

      copyUrl() {
        this.$copyText(this.getLeadCaptureUrl(this.broker.id)).then(function (e) {
          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'Link copied.'
          })
          // alert('Copied')
          // console.log(e)
        }, function (e) {
          // alert('Can not copy')
          // console.log(e)
        })
      },

      submit() {
        this.loading = true
        this.apiPost({
          enabled : this.leadCaptureEnabled,
          fbPixel : btoa(this.fbPixel)
        }, 'broker/lead-capture', () => {
          this.loading = false
          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'Saved successfully.'
          }) 
        })
      }
    },
  }
</script>